import React from 'react';
import { Box, Container, Skeleton, Paper, Grid } from '@mui/material';

const DashboardSkeleton: React.FC = () => {
    return (
        <Container disableGutters maxWidth={false} sx={{ mt: 0.5, pl: 1, pr: 1 }}>
            {/* Header skeleton */}
            <Paper sx={{ p: 1, mb: 1, borderRadius: 2 }}>
                <Grid container spacing={0}>
                    {/* Nadpis + čas */}
                    <Grid size={{ xs: 12 }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} flexWrap="wrap" gap={1}>
                            <Skeleton variant="text" width={200} height={80} />
                            <Skeleton variant="text" width={120} height={60} />
                        </Box>
                    </Grid>

                    {/* Informace o výjezdu */}
                    <Grid size={{ xs: 12, md: 5 }}>
                        <Box pb={{ xs: 2, md: 4 }}>
                            <Skeleton variant="text" width="80%" height={50} />
                        </Box>
                        <Skeleton variant="text" width="60%" height={30} sx={{ mb: 1 }} />
                        <Skeleton variant="text" width="70%" height={30} sx={{ mb: 1 }} />
                        <Skeleton variant="text" width="50%" height={30} sx={{ mb: 1 }} />

                        {/* Technika skeleton */}
                        <Box sx={{ mt: 3 }}>
                            <Skeleton variant="text" width={100} height={25} />
                            <Skeleton variant="text" width="40%" height={20} />
                            <Skeleton variant="text" width="35%" height={20} />
                        </Box>
                    </Grid>

                    {/* Mapa skeleton */}
                    <Grid size={{ xs: 12, md: 7 }}>
                        <Skeleton
                            variant="rectangular"
                            sx={{
                                height: { xs: 300, sm: 400, md: 500 },
                                borderRadius: 2,
                                mt: { xs: 2, md: 0 }
                            }}
                        />
                    </Grid>
                </Grid>
            </Paper>

            {/* Odpovědi skeleton */}
            <Box sx={{ pt: { xs: 1, md: 2 } }}>
                <Grid container spacing={2} alignItems="flex-start" justifyContent="center">
                    {/* Levý sloupec – Role skeleton */}
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Box display="flex" flexDirection={{ xs: 'row', md: 'column' }} flexWrap="wrap" gap={1} justifyContent={{ xs: 'center', md: 'flex-start' }}>
                            {[1, 2, 3].map((i) => (
                                <Skeleton
                                    key={i}
                                    variant="rounded"
                                    sx={{
                                        width: { xs: 130, sm: 150, md: 160 },
                                        height: { xs: 36, md: 40 },
                                        borderRadius: 2,
                                    }}
                                />
                            ))}
                        </Box>
                    </Grid>

                    {/* Střední sloupec – JEDU / NEJEDU skeleton */}
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Box display="flex" gap={{ xs: 2, md: 5, xl: 6 }} justifyContent="center" flexWrap="wrap">
                            <Skeleton
                                variant="rounded"
                                sx={{
                                    width: { xs: 140, sm: 180, md: 240, xl: 320 },
                                    height: { xs: 100, sm: 120, md: 150, xl: 200 },
                                    borderRadius: 4,
                                }}
                            />
                            <Skeleton
                                variant="rounded"
                                sx={{
                                    width: { xs: 140, sm: 180, md: 240, xl: 320 },
                                    height: { xs: 100, sm: 120, md: 150, xl: 200 },
                                    borderRadius: 4,
                                }}
                            />
                        </Box>
                    </Grid>

                    {/* Pravý sloupec – Čas vyhlášení skeleton */}
                    <Grid size={{ xs: 12, md: 4 }} display="flex" justifyContent={{ xs: 'center', md: 'flex-end' }}>
                        <Skeleton
                            variant="rounded"
                            sx={{
                                width: { xs: '100%', sm: 200, md: 240 },
                                maxWidth: 300,
                                height: { xs: 80, sm: 100, md: 150 },
                                borderRadius: 4,
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default DashboardSkeleton;
